module.exports = __webpack_public_path__ + "img/91.53cb9501.jpg";